const StatusOptions = {
  ACTIVE: "active",
  INACTIVE: "inactive",
};

export { StatusOptions };
